// The improved version of the My Intrivity Application
import { html, css, LitElement } from 'lit-element';
import { unsafeHTML } from 'lit-html/directives/unsafe-html.js';
import { clone, cloneDeep } from 'lodash-es';
import { library, dom } from "@fortawesome/fontawesome-svg-core";   
 
import './badge.js';
import './login_dialog.js';
import './language_picker.js';

import {
    emitEvent, INTRIVITY_LOGIN, INTRIVITY_LOGOUT , INTRIVITY_PRINTABLE_TOGGLE, INTRIVITY_AI_SUMMARY
} from './utility.js'
import { a11yStyles } from './a11y.js';
import { t, Localized } from './i18n.js';

export class IntrivityHeaderApp extends Localized(LitElement) {

    static get styles() {
        return [a11yStyles, css`
            .header {
                width: 100%;
                align-self: flex-end;
                display: grid;
                grid-template-columns: 1fr 5fr 1fr 1fr;
            }
            .header-action {
                text-align: right;
                margin-right: 50px;
                position: relative;
                padding-right: 20px;
            }
            .header-action.print {
                margin-right: 30px;
                padding-right: 10px;
            }
            /* The link-styled controls sit on the orange banner; black text on
               rgb(250,166,53) is 10.5:1, comfortably past WCAG AA. */
            .header-action button,
            .header-action a {
                position: absolute;
                bottom: 10px;
                right: 20px;
                color: #1a1a1a;
                text-decoration: underline;
                /* The cell is narrow; Japanese and Chinese would otherwise
                   break these labels between any two characters. */
                white-space: nowrap;
            }
            .header-action.print button {
                right: 10px;
            }
            .header-language {
                display: flex;
                align-items: flex-end;
                justify-content: flex-end;
                padding-bottom: 10px;
                /* Room for a longer label in the next cell, which overflows leftward. */
                padding-right: 30px;
            }
        `];
    }
    
    static get properties() {
        return {
            user_profile: { type: Object },
            m: { type: Number },
            r: { type: Number },
            t: { type: Number },
            s: { type: Number },
            size: { type: Number },
            first: { type: String },
            printable: { type: Boolean },
            anon: { type: Boolean },
            _showLoginDialog: { type: Boolean }
        };
    }

    constructor() {
        super();
        this.size = 1;
        this.m = -1;
        this.r = -1;
        this.t = -1;
        this.s = -1;
        this._showLoginDialog = false;
    }

    render() {
        return html`
            <header style="display: flex; height: 130px; background-color: rgb(250, 166, 53);">
                <div class="header">
                    <div style="text-align: right; padding-left: 60px;">
                        <img style="height: 60px;" src="./images/intrivity.png" alt=${t('header.logoAlt')} />
                    </div>    
                    <div class="header-language"><intrivity-language-picker></intrivity-language-picker></div>
                    ${this.anon ? html`` : html`
                        ${this.printable ? html`
                            <div class="header-action print">
                                <button class="unstyled-button" type="button" @click=${(e) => { window.print(); }}>${t('header.printPdf')}</button>
                            </div>

                            <div class="header-action">
                                <button class="unstyled-button" type="button" @click=${(e) => { emitEvent(INTRIVITY_PRINTABLE_TOGGLE, {}, this); }}>${t('header.return')}</button>
                            </div>
                            ` : html`
                            <div class="header-action">
                                <a href="https://intrivity.com/contact/" target="_blank" rel="noopener">${t('header.contact')}</a>
                            </div>
                            ${this.user_profile ? html`
                                <div class="header-action">
                                    <button class="unstyled-button" type="button" @click=${(e) => { emitEvent(INTRIVITY_LOGOUT, {}, this); }}>${t('header.logout')}</button>
                                </div>
                            `: html`
                                <div class="header-action">
                                    <button class="unstyled-button" type="button" @click=${(e) => { this._showLoginDialog = true; }}>${t('header.login')}</button>
                                </div>
                            `}
                        `}
                    `}
                </div>
            </header>
            <intrivity-login-dialog .open=${this._showLoginDialog} @dialog-closed=${() => this._showLoginDialog = false}></intrivity-login-dialog>
        `
    }

 
}
if (!customElements.get('intrivity-header')) customElements.define('intrivity-header', IntrivityHeaderApp);
